import { render, staticRenderFns } from "./addContent.vue?vue&type=template&id=50bc73d0&scoped=true&"
import script from "./addContent.vue?vue&type=script&lang=js&"
export * from "./addContent.vue?vue&type=script&lang=js&"
import style0 from "./addContent.vue?vue&type=style&index=0&id=50bc73d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bc73d0",
  null
  
)

export default component.exports